export default IconStairsUp => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-stairs-up" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M22 6h-5v5h-5v5h-5v5h-5" />
  <path d="M6 10v-7" />
  <path d="M3 6l3 -3l3 3" />
</svg>`;